import { render, staticRenderFns } from "./watsonAssistant_1.vue?vue&type=template&id=2cb7cdce"
import script from "./watsonAssistant_1.vue?vue&type=script&lang=js"
export * from "./watsonAssistant_1.vue?vue&type=script&lang=js"
import style0 from "./watsonAssistant_1.vue?vue&type=style&index=0&id=2cb7cdce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports